import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { SelectData } from '../form/select/model';

@Component({
  selector: 'smarsh-custom-dropdown-button-with-checkbox',
  templateUrl: './custom-dropdown-button-with-checkbox.component.html',
  styleUrls: ['./custom-dropdown-button-with-checkbox.component.scss']
})
export class CustomDropdownButtonWithCheckboxComponent implements OnInit {
  @Input()
  label: string;

  @Input()
  list: SelectData[];

  @Input()
  popupStyle: 'dropup' | 'dropdown' = 'dropdown';

  @Input()
  btnStyle: '' | 'btn-secondary' | 'btn-outline-primary' = '';

  @Input()
  btnTextStyle: '' | 'btn-text-white' = '';

  @Input()
  id = 'dropdownMenu';

  @Input()
  btnSize: '' | 'dropdown-btn-large' = '';

  @Input()
  dropMenuAlignment: '' | 'dropdown-menu-right' = '';

  @Input()
  btnFixSize: '' | '100' = '';

  @Input()
  selectAllState = true;

  @Input()
  selectAllText: string | '' = 'Select All';

  @Input()
  selectAllPlaceholder: string | '' = '';

  @Input()
  initialSelectionList: string[] | '' = [];

  @Input()
  permanentlyCheckedId: string | number | '' = '';

  btnStyleDefault = 'btn dropdown-toggle';

  dropMenuDefault = 'dropdown-menu dropdown-cursor';

  btnLabelDefault = 'd-inline-block text-truncate btn-label-size';

  @Output()
  changeItem = new EventEmitter<string[]>();

  @Output()
  changeItemName = new EventEmitter<string>();

  toggle: boolean;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedItemList: any[] = [];
  selectAll: boolean;
  objList = [];

  ngOnInit() {
    this.setSelectAllCheckStatus();
    this.setObjectListCheckStatus();

    this.btnStyleDefault = this.btnStyleDefault
      .concat(' ')
      .concat(this.btnStyle)
      .concat(' ')
      .concat(this.btnTextStyle)
      .concat(' ')
      .concat(this.btnSize);

    this.btnLabelDefault = this.btnLabelDefault.concat(' ');
    this.dropMenuDefault = this.dropMenuDefault
      .concat(' ')
      .concat(this.dropMenuAlignment);
  }
  setObjectListCheckStatus() {
    if (this.initialSelectionList.length) {
      this.selectAll = false;
      this.list.forEach((obj) => {
        if (this.initialSelectionList.includes(obj.name)) {
          this.objList.push({ ...obj, isSelected: true });
          this.label = '';
          this.label = this.label.trim().concat(obj.name).concat(',');
        } else {
          this.objList.push({ ...obj, isSelected: false });
        }
      });
    } else {
      this.objList = this.list.map((obj) => ({
        ...obj,
        isSelected: this.selectAll
      }));
    }
  }
  setSelectAllCheckStatus() {
    this.selectAll =
      this.selectAllState !== undefined ? this.selectAllState : true;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event) {
    if (
      this.toggle &&
      event.target &&
      event.target.id !== 'orgDropdown' &&
      !event.target.id.toString().includes('item') &&
      !event.target.id.toString().includes('selectAllCheck')
    ) {
      this.toggle = false;
    }
  }

  isPermanentlyCheckedItem(id: string): boolean {
    return id.toString() === this.permanentlyCheckedId.toString();
  }

  checkSelectedItem() {
    this.selectAll = this.objList.every((obj) => {
      return obj.isSelected === true;
    });
    this.setSelectionList();
    this.sendSelectList();
  }

  toggleSelectAll() {
    this.objList.forEach((obj) => {
      if (obj.id.toString() !== this.permanentlyCheckedId.toString()) {
        obj.isSelected = this.selectAll;
      }
    });

    this.setSelectionList();
    this.sendSelectList();
  }

  sendSelectList() {
    this.changeItemName.emit(this.label);
    this.changeItem.emit(this.selectedItemList);
  }

  setSelectionList() {
    this.selectedItemList = [];
    this.label = '';
    if (!this.selectAll) {
      this.objList.forEach((obj) => {
        if (obj.isSelected) {
          this.selectedItemList.push({ id: obj.id, name: obj.name });
          // ToDo
          this.label = this.label.trim().concat(obj.name).concat(', ');
        }
      });
    } else {
      this.label = this.selectAllPlaceholder;
    }
  }
}
